// Tasks Vuex module
import { createBaseModule } from './base'
import { tasksApi } from '@/services/api'

const customActions = {
  async assign({ commit }, { id, assigned_to }) {
    try { commit('SET_LOADING', true); commit('CLEAR_ERROR'); return await tasksApi.assign(id, assigned_to) }
    finally { commit('SET_LOADING', false) }
  },
  async complete({ commit }, { id, data = {} }) {
    try { commit('SET_LOADING', true); commit('CLEAR_ERROR'); return await tasksApi.complete(id, data) }
    finally { commit('SET_LOADING', false) }
  },
  async listByWorkstream({ commit }, workstreamId) {
    try {
      commit('SET_LOADING', true); commit('CLEAR_ERROR');
      const res = await tasksApi.listByWorkstream(workstreamId)
      // API shape: { tasks: [...] }
      return res?.tasks || []
    } finally { commit('SET_LOADING', false) }
  },
  async addAgent({ commit }, { id, agent_id }) {
    try { commit('SET_LOADING', true); commit('CLEAR_ERROR'); return await tasksApi.addAgent(id, agent_id) }
    finally { commit('SET_LOADING', false) }
  },
  async removeAgent({ commit }, { id, agent_id }) {
    try { commit('SET_LOADING', true); commit('CLEAR_ERROR'); return await tasksApi.removeAgent(id, agent_id) }
    finally { commit('SET_LOADING', false) }
  }
}

export default createBaseModule('task', tasksApi, { customActions })
